"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop2 = _interopRequireDefault(require("lodash-es/noop"));

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          font-weight: 14px;\n          font-weight: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  text-align: start;\n  ", " \n  color: ", ";\n  cursor: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getColors = function getColors(props) {
  var breadCrumbsColors = (0, _versions.getColor)(props, 'breadCrumbs');
  var linkColors = (0, _versions.getColor)(props, 'link');
  return {
    breadCrumbsColors: breadCrumbsColors,
    linkColors: linkColors
  };
};

var CrumbLink = _styledComponents["default"].a(_templateObject(), function (props) {
  return props.selected ? (0, _styledComponents.css)(_templateObject2(), _tokens.fonts.weight.semiBold) : (0, _styledComponents.css)(_templateObject3());
}, function (props) {
  return props.selected ? getColors(props).breadCrumbsColors.selected : getColors(props).breadCrumbsColors.unselected;
}, function (props) {
  return props.selected ? 'default' : 'pointer';
}, function (props) {
  return !props.selected ? getColors(props).linkColors.defaultHover : null;
});

var Navigation = _styledComponents["default"].div(_templateObject4(), _tokens.spacing.small, _tokens.spacing.xsmall);

var Separator = _styledComponents["default"].span(_templateObject5(), function (props) {
  return getColors(props).breadCrumbsColors.separator;
});

var Breadcrumbs =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Breadcrumbs, _React$Component);

  function Breadcrumbs(props) {
    var _this;

    _classCallCheck(this, Breadcrumbs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Breadcrumbs).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeCrumb", function (changeToValue) {
      var selectedValue = _this.state.selectedCrumb.props.value;

      if (selectedValue !== changeToValue) {
        _react["default"].Children.map(_this.props.children, function (child) {
          if (child.props.value === changeToValue) _this.setState({
            selectedCrumb: child
          }, function () {
            return _this.props.onChange(changeToValue);
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "expandCrumbs", function () {
      _this.setState({
        expanded: true
      });
    });

    var crumbs = _react["default"].Children.map(props.children, function (child) {
      return {
        value: child.props.value,
        label: child.props.label
      };
    });
    /* select last by default */


    var selectedCrumb = props.children[props.children.length - 1];

    _react["default"].Children.map(props.children, function (child) {
      /* override if selected */
      if (child.props.selected) selectedCrumb = child;
    });

    var expanded = crumbs.length > 5 ? false : true;
    _this.state = {
      crumbs: crumbs,
      expanded: expanded,
      selectedCrumb: selectedCrumb
    };
    return _this;
  }

  _createClass(Breadcrumbs, [{
    key: "renderCrumb",
    value: function renderCrumb(_ref, index, crumbs) {
      var value = _ref.value,
          label = _ref.label;
      var first = index === 0;
      var second = index === 1;
      var last = index === crumbs.length - 1;
      var changeCrumb = this.changeCrumb,
          expandCrumbs = this.expandCrumbs,
          selectedCrumbValue = this.selectedCrumbValue,
          expanded = this.expanded,
          version = this.version;

      if (expanded || first || last) {
        return _react["default"].createElement("span", {
          key: value
        }, _react["default"].createElement(CrumbLink, {
          key: value,
          onClick: function onClick() {
            return changeCrumb(value);
          },
          selected: value === selectedCrumbValue,
          version: version
        }, label), !last && _react["default"].createElement(Separator, {
          version: version
        }, " / "));
      }

      if (second) {
        return _react["default"].createElement("span", {
          key: value
        }, _react["default"].createElement(CrumbLink, {
          key: value,
          onClick: expandCrumbs,
          version: version
        }, "..."), _react["default"].createElement(Separator, {
          version: version
        }, " / "));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          selectedCrumb = _this$state.selectedCrumb,
          crumbs = _this$state.crumbs,
          expanded = _this$state.expanded;
      var selectedCrumbValue = selectedCrumb.props.value;
      return _react["default"].createElement(Navigation, null, crumbs.map(this.renderCrumb, {
        changeCrumb: this.changeCrumb,
        expandCrumbs: this.expandCrumbs,
        selectedCrumbValue: selectedCrumbValue,
        expanded: expanded,
        version: this.props.version
      }));
    }
  }]);

  return Breadcrumbs;
}(_react["default"].Component);

Breadcrumbs.Crumb = _styledComponents["default"].span(_templateObject6());
Breadcrumbs.Crumb.propTypes = {
  /** Unique identifier for a crumb */
  value: _propTypes["default"].string.isRequired,

  /* Label for a crumb */
  label: _propTypes["default"].string.isRequired,

  /** Selected by default? */
  selected: _propTypes["default"].bool
};
Breadcrumbs.propTypes = {
  /** Callback function to be called on crumbChange [value of the selected crumb will be sent] */
  onChange: _propTypes["default"].func
};
Breadcrumbs.defaultProps = {
  onChange: _noop2["default"]
};
Breadcrumbs.displayName = 'Breadcrumbs';

var _default = (0, _context.withVersion)(Breadcrumbs);

exports["default"] = _default;